import { useNavigate } from "react-router-dom";

function Dashboard() {
  const navigate = useNavigate();

  return (
    <div className="dashboard-hero">
      <div className="page-container">
        {/* Title appears first */}
        <h1 className="navbar-logo-text animate-in delay-1">
          Welcome to QAP Financials
        </h1>

        {/* Subtitle appears second */}
        <p className="dashboard-subtitle animate-in delay-2">
          Manage your companies, generate financial reports, and control your
          subscription from one place.
        </p>

        <div className="dashboard-cards">
          {/* Card 1 */}
          <div 
            className="dashboard-card animate-in delay-3" 
            onClick={() => navigate("/generate")}
          >
            <h3>Generate Reports</h3>
            <p className="card-subtitle">
              Create Balance Sheet, Profit & Loss, and Cash Flow reports across companies.
            </p>
            <span className="card-link">Go to Generate →</span>
          </div>

          {/* Card 2 */}
          <div 
            className="dashboard-card animate-in delay-4" 
            onClick={() => navigate("/companies")}
          >
            <h3>Manage Companies</h3>
            <p className="card-subtitle">
              Connect accounts, group companies, and manage reporting structure.
            </p>
            <span className="card-link">Go to Companies →</span>
          </div>

          {/* Card 3 */}
          <div 
            className="dashboard-card animate-in delay-5" 
            onClick={() => navigate("/profile")}
          >
            <h3>Profile & Subscription</h3>
            <p className="card-subtitle">
              View account details, manage subscription, and control access.
            </p>
            <span className="card-link">Go to Profile →</span>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Dashboard;
